import React from 'react';
import { Heart } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-gray-500 py-10 px-4 text-center text-sm border-t border-gray-800" data-id="element-125">
      <div className="max-w-6xl mx-auto" data-id="element-126">
        <div className="flex justify-center items-center gap-2 mb-6" data-id="element-127">
          <span className="font-bold text-white text-lg" data-id="element-128">
            Mega Pack Anti-Pantallas
          </span>
        </div>

        <p className="mb-6 flex items-center justify-center gap-1" data-id="element-129">
          Hecho con <Heart className="w-4 h-4 text-red-500 fill-red-500" data-id="element-130" /> para
          familias felices
        </p>

        <p className="mb-4" data-id="element-131">
          © {new Date().getFullYear()} Mega Pack Anti-Pantallas. Todos los
          derechos reservados.
        </p>

        <p className="text-xs text-gray-700 max-w-2xl mx-auto" data-id="element-132">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}